// Results page course chips (team#70).
//   The server already honours ?course=<slug> (chips are plain links). With JS a
//   tap filters the cards in place and keeps the URL in step via replaceState.
//   ?q= (the search, team#71) is carried over so both survive reload and sharing.
export function activeCourse(root = document) {
  const on = root.querySelector('.course-chip[aria-current]');
  return on ? on.dataset.course || '' : '';
}

export function applyCourse(slug, root = document) {
  root.querySelectorAll('.v2-page [data-course]').forEach((card) => {
    if (card.classList.contains('course-chip')) return;
    const hide = !!slug && card.dataset.course !== slug;
    card.hidden = hide;
    if (hide && card.classList.contains('expanded')) {
      card.classList.remove('expanded');
      if (window.TL && TL.views && TL.views.hideOverlay) TL.views.hideOverlay();
    }
  });
  root.querySelectorAll('.course-chip').forEach((chip) => {
    const on = chip.dataset.course === slug;
    chip.classList.toggle('active', on);
    if (on) chip.setAttribute('aria-current', 'true');
    else chip.removeAttribute('aria-current');
  });
  root.dispatchEvent(new CustomEvent('coursechange', { detail: { course: slug } }));
}

export function setCourse(slug, { root = document, history: hist = window.history } = {}) {
  const chip = root.querySelector(`.course-chip[data-course="${slug}"]`);
  if (!chip) return false;
  applyCourse(slug, root);
  const url = new URL(chip.getAttribute('href'), window.location.href);
  const q = new URLSearchParams(window.location.search).get('q');
  url.searchParams.delete('q');
  if (q) url.searchParams.set('q', q);
  hist.replaceState(null, '', url.pathname + url.search);
  return true;
}

export function initCourseChips({ root = document, history: hist = window.history } = {}) {
  const row = root.querySelector('.course-chips');
  if (!row) return;
  row.addEventListener('click', (e) => {
    const chip = e.target.closest('.course-chip');
    if (!chip || e.defaultPrevented) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    setCourse(chip.dataset.course, { root, history: hist });
  });
}
